import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DialogModule } from '@openng/optimus-ui/dialog';

import { AppConfigErrorDialogService } from '@app/theme/services/app-config-error-dialog.service';

@Component({
    selector: 'cor-app-config-error-dialog',
    templateUrl: './app-config-error-dialog.component.html',
    imports: [DialogModule, ButtonModule, NgOptimizedImage],
})
export class AppConfigErrorDialogComponent {
    protected readonly appConfigErrorDialogService = inject(AppConfigErrorDialogService);

    reloadPage() {
        window.location.reload();
    }
}
